module.exports = __webpack_public_path__ + "img/galeria-video-1.5e0da52e.png";